import { XIcon } from '@repo/ui/icons'
import Modal from '@repo/ui/modal'
import { PropsWithChildren } from 'react'

type Props = {
  isLoading?: boolean
  isOpen: boolean
  onCancel?: () => void
  onConfirm?: () => void
}

const MissionStaffCancellationModal = ({
  children,
  isOpen,
  isLoading,
  onCancel,
  onConfirm
}: PropsWithChildren<Props>) => {
  return (
    <Modal
      onCancel={onCancel ?? (() => {})}
      isOpen={isOpen}
      title={'Êtes-vous sûr(e) de vouloir annuler ?'}
      isLoading={isLoading}
      variant={'destructive'}
      icon={XIcon}
      hideActions={children !== undefined}
      actionButtonsOptions={{
        confirmText: 'Annuler',
        cancelText: 'Fermer',
        onConfirm: onConfirm
      }}
    >
      {children}
    </Modal>
  )
}

export default MissionStaffCancellationModal
